<template>
  <!-- 短重退差列表 -->
  <div class="bj short-weight-difference">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:right>
        <el-button
          type="warning"
          :disabled="!tableData.length || disabledExport"
          @click="exportHandle"
          icon="el-icon-upload2"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          prop="logisticBusinessName"
          align="center"
          label="集配中心"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.logisticBusinessName">{{
              $empty.empty(scope.row.logisticBusinessName)
            }}</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" align="center" label="订单编号">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.orderNo) }}
          </template>
        </el-table-column>
        <el-table-column prop="sourceName" align="center" label="退款类型"
          ><template slot-scope="scope">
            {{ scope.row.sourceName || "—" }}
          </template></el-table-column
        >
        <el-table-column prop="tradeNo" align="center" label="微信交易单号"
          ><template slot-scope="scope">
            {{ scope.row.tradeNo || "—" }}
          </template></el-table-column
        >
        <el-table-column prop="supplierOrderNo" align="center" label="供货单号"
          ><template slot-scope="scope">
            {{ scope.row.supplierOrderNo || "—" }}
          </template></el-table-column
        >
        <el-table-column prop="createTime" align="center" label="订单创建时间">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="fullname" align="center" label="客户名称">
          <template slot-scope="scope" v-if="scope.row.fullname">
            {{ $empty.empty(scope.row.fullname) }}
          </template>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="客户电话">
          <template slot-scope="scope" v-if="scope.row.mobile">
            {{ $empty.empty(scope.row.mobile) }}
          </template>
        </el-table-column>
        <el-table-column prop="payAt" align="center" label="支付时间">
          <template slot-scope="scope">
            {{ $empty.time(scope.row.payAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="statueName" align="center" label="退款状态">
        </el-table-column>
        <el-table-column prop="payAmount" align="center" label="订单金额">
        </el-table-column>
        <el-table-column prop="logisticsName" align="center" label="城市仓">
        </el-table-column>
        <el-table-column prop="deliveryName" align="center" label="自提点">
        </el-table-column>
        <el-table-column prop="refundAmount" align="center" label="退款金额">
        </el-table-column>
        <el-table-column prop="refundNo" align="center" label="退款单号">
        </el-table-column>
        <el-table-column prop="title" align="center" label="短重商品">
        </el-table-column>
        <el-table-column
          prop="differenceWeight"
          align="center"
          label="短重重量(斤)"
        >
        </el-table-column>
        <el-table-column prop="opUserName" align="center" label="操作人">
          <template slot-scope="scope">
            {{ scope.row.opUserName
            }}{{ scope.row.opTypeName ? `(${scope.row.opTypeName})` : "" }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import utilsTool from "@/utils/tools/tool";
import cloneDeep from "lodash/cloneDeep";
import Filtersearch from "@/components/Filtersearch.vue";
import { downLoadFlowBlob } from "@/utils/tools/base";
import { postRefundDifferencePriceListExport } from "@/api/allExport";
import { formatDate } from "@/utils//tools/date.js";
export default {
  name: "ShortWeightDifference",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "input",
          name: "货号",
          clearable: true,
          model: "sku_code",
          placeholder: "请输入货号",
        },
        {
          type: "daterange",
          name: "供货日期",
          clearable: true,
          model: "supplier_at",
          startmodel: "supplier_order_cycle_start",
          endmodel: "supplier_order_cycle_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          format: "yyyy-MM-dd",
        },
        {
          type: "daterange",
          name: "订单支付时间",
          clearable: true,
          model: "pay_at",
          startmodel: "pay_at_start",
          endmodel: "pay_at_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          format: "yyyy-MM-dd",
        },
        {
          type: "input",
          name: "订单号",
          clearable: true,
          model: "order_no",
          placeholder: "请输入订单号",
        },
        {
          type: "input",
          name: "供货单号",
          clearable: true,
          model: "supplier_order_no",
          placeholder: "请输入供货单号",
        },
        {
          type: "daterange",
          name: "退款时间",
          clearable: true,
          model: "refund_at",
          startmodel: "refund_at_start",
          endmodel: "refund_at_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          format: "yyyy-MM-dd",
        },
        {
          type: "input",
          name: "客户姓名",
          clearable: true,
          model: "member_name",
          placeholder: "请输入客户姓名",
        },
        {
          type: "input",
          name: "客户电话",
          clearable: true,
          model: "member_mobile",
          placeholder: "请输入客户电话",
        },
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选择集配中心",
          selectoptionname: "businessList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "退差类型",
          clearable: true,
          model: "source",
          placeholder: "请选择退差类型",
          label: "name",
          value: "id",
          selectoption: [
            {
              name: "短重退差",
              id: 1,
            },
            {
              name: "退差价",
              id: 2,
            },
          ],
        },
      ],
      //列表新建页面初始参数
      loading: true,
      utilsTool,
      from: {
        sku_code: "",
        supplier_at: [formatDate(new Date()), formatDate(new Date())],
        supplier_order_cycle_start: formatDate(new Date()),
        supplier_order_cycle_end: formatDate(new Date()),
        pay_at: [],
        pay_at_start: "",
        pay_at_end: "",
        order_no: "",
        supplier_order_no: "",
        refund_at: [],
        refund_at_start: "",
        refund_at_end: "",
        member_name: "",
        member_mobile: "",
        logistic_business_id: "",
        source: "",
        page: 1,
        pageSize: 50,
      },
      formDataClone: {}, // 复制一份 初始化数据
      tableData: [],
      currentPage: 1,
      total: 0,
      options: [],
      disabledExport: false, // 导出禁用
    };
  },
  computed: {},
  created() {
    this.formDataClone = cloneDeep(this.from);
    this.hqlist();
    this.getBusinessList();
  },
  methods: {
    // 集配中心列表
    getBusinessList() {
      this.$api.general.businessList().then((res) => {
        this.options = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "businessList"
          ) {
            el.selectoption = [{ id: "", name: "全部" }, ...res.data];
          }
        });
      });
    },
    /* 导出 */
    async exportHandle() {
      this.disabledExport = true;
      this.$message.success("正在导出，请耐心等待");
      try {
        const params = {
          ...this.from,
        };
        delete params.page;
        delete params.pageSize;
        const res = await postRefundDifferencePriceListExport(params);
        downLoadFlowBlob(res, res?.filename);
        this.$message.success("导出成功");
      } catch (err) {
        this.$message.error("导出失败了");
        console.log("ajax getTakeOrderPlacenoExport err", err);
      } finally {
        this.disabledExport = false;
      }
    },
    search(e) {
      this.from = e;
      this.from.page = 1;
      this.currentPage = 1;
      this.hqlist();
    },
    Refresh() {
      this.from = {
        ...this.formDataClone,
      };
      this.tableData = [];
      this.hqlist();
      this.currentPage = 1;
      console.log(this.from);
    },
    handleSizeChange(val) {
      this.from.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.currentPage = val;
      this.hqlist();
    },
    hqlist() {
      let form = cloneDeep(this.from);
      try {
        this.loading = true;
        this.$api.general.refundDifferencePriceList(form).then((res) => {
          console.log(res, "获取数据");
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.loading = false;
        });
      } catch (err) {
        console.log("ajax err", err);
      }
    },
  },
};
</script>
<style lang="scss">
.short-weight-difference {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .checked-box {
    padding: 13px 15px;
  }

  .order-wrapper {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    background: #ffffff;
    padding: 10px 15px;

    .inputs {
      margin-right: 10px;
      margin-bottom: 10px;
    }

    .multiple-select {
      width: 250px;
    }
    .multiple-select-long {
      width: 320px;
      .el-select__input {
        height: auto;
      }
    }
  }

  .top {
    display: flex;
    align-items: center;
    .span {
      width: 100px;
    }
    &:nth-of-type(1),
    &:nth-of-type(4),
    &:nth-of-type(5) {
      margin-left: 15px;
    }
  }
  .mid {
    height: 36px;
    line-height: 36px;
  }
  .title {
    background: #ffffff;
    padding-top: 10px;
    padding-left: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    .inputs {
      display: flex;
      align-items: center;
    }
    .seach {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;

      .multiple-select {
        width: 250px;
      }
    }

    .bjsearch {
      background: #333333;
      border-color: #333333;
    }
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .contents {
    padding-left: 55px;
    padding-right: 55px;
    padding-top: 23px;

    box-sizing: border-box;

    .titlname {
      font-size: 17px;
      color: #21c2ac;
      margin-bottom: 25px;
    }

    .imgs {
      display: flex;

      .imglist {
        width: 165px;
        height: 123px;
        border: 1px dashed #a4adc5;
        padding: 14px 8px;
        text-align: center;
        border-radius: 7px;
        box-sizing: border-box;
        margin-right: 16px;

        .div {
          margin-top: 20px;
          padding-bottom: 20px;
        }
      }
    }

    .disply {
      display: flex;
      margin-bottom: 22px;
    }

    .mr {
      margin-right: 31px;
    }

    .iteminput {
      display: flex;
      align-items: center;

      .wen {
        width: 77px;
        margin-right: 24px;
        color: #000;
        font-size: 14px;
        text-align: right;
      }

      .el-input {
        width: 302px;
      }
    }
  }
}
</style>
